<template>
    <a :href="href"
       target="_blank"
       class="opui-btn opui-btn-danger"
    >
        {{ text }}
    </a>
</template>

<script>
export default {
    props: {
        href: { type: String, default: 'https://my.optimizepress.com/account/upgrade' },
        text: { type: String, default: 'Upgrade' },
    },
}
</script>
